/**
 * 墨学分支 (⚙️ 机关科技) - 共18项
 * 严格按照 docs/TECH_TREE_DESIGN.md 设计
 */

import type { Tech } from '../TechTypes';

export const MOXUE_TECHS: Tech[] = [
  // 第一层：基础机关 (3项)
  {
    id: 'M001',
    name: '墨子守城',
    description: '守御之术',
    branch: 'moxue',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { defenseBonus: 1.15 },
    },
    position: { x: 20, y: 10 },
    icon: '🛡️',
  },
  {
    id: 'M002',
    name: '机括之术',
    description: '机械基础',
    branch: 'moxue',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { siegeBonus: 1.1 },
    },
    position: { x: 50, y: 10 },
    icon: '⚙️',
  },
  {
    id: 'M003',
    name: '木牛流马',
    description: '运输机关',
    branch: 'moxue',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { speedBonus: 1.2 },
    },
    position: { x: 80, y: 10 },
    icon: '🐴',
  },

  // 第二层：进阶机关 (5项)
  {
    id: 'M011',
    name: '连弩机关',
    description: '守城弩机',
    branch: 'moxue',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['M001', 'M002'],
    effects: {
      bonuses: { archerAttack: 1.25, archerRange: 1.2 },
    },
    position: { x: 10, y: 25 },
    icon: '🏹',
  },
  {
    id: 'M012',
    name: '投石之车',
    description: '攻城机关',
    branch: 'moxue',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['M002'],
    effects: {
      bonuses: { siegeBonus: 1.2 },
    },
    position: { x: 30, y: 25 },
    icon: '🪨',
  },
  {
    id: 'M013',
    name: '陷阱机关',
    description: '防御陷阱',
    branch: 'moxue',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['M001'],
    effects: {
      bonuses: { defenseBonus: 1.3 },
    },
    position: { x: 50, y: 25 },
    icon: '🕳️',
  },
  {
    id: 'M014',
    name: '自动仓储',
    description: '仓储系统',
    branch: 'moxue',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['M003'],
    effects: {
      bonuses: { goldCapacity: 1.4, speedBonus: 1.3 },
    },
    position: { x: 70, y: 25 },
    icon: '📦',
  },
  {
    id: 'M015',
    name: '机关傀儡',
    description: '人形机关',
    branch: 'moxue',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['M002', 'M003'],
    effects: {
      bonuses: { upkeepReduction: 1.2 },
    },
    position: { x: 90, y: 25 },
    icon: '🤖',
  },

  // 第三层：高级机关 (5项)
  {
    id: 'M021',
    name: '九宫八卦阵',
    description: '阵法机关',
    branch: 'moxue',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['M011', 'M013'],
    effects: {
      bonuses: { defenseBonus: 1.35, archerAttack: 1.2 },
    },
    position: { x: 10, y: 45 },
    icon: '🔮',
  },
  {
    id: 'M022',
    name: '霹雳战车',
    description: '攻城重器',
    branch: 'moxue',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['M012'],
    effects: {
      bonuses: { siegeBonus: 1.4 },
    },
    position: { x: 30, y: 45 },
    icon: '⚡',
  },
  {
    id: 'M023',
    name: '飞剑绝杀',
    description: '杀伐机关',
    branch: 'moxue',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['M011', 'M015'],
    effects: {
      bonuses: { attackBonus: 1.35 },
    },
    position: { x: 50, y: 45 },
    icon: '🗡️',
  },
  {
    id: 'M024',
    name: '传送机关',
    description: '时空机关：城市间资源瞬时传送',
    branch: 'moxue',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['M014'],
    effects: {
      bonuses: { speedBonus: 1.5 },
    },
    position: { x: 70, y: 45 },
    icon: '🌀',
  },
  {
    id: 'M025',
    name: '铁甲战兽',
    description: '战兽机关',
    branch: 'moxue',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['M015'],
    effects: {
      bonuses: { attackBonus: 1.25, defenseBonus: 1.2 },
    },
    position: { x: 90, y: 45 },
    icon: '🦏',
  },

  // 第四层：大师机关 (3项)
  {
    id: 'M031',
    name: '墨门绝学',
    description: '墨学大成：所有机关效率+50%',
    branch: 'moxue',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['M021', 'M023'],
    effects: {
      bonuses: { defenseBonus: 1.5, researchSpeedBonus: 1.3 },
    },
    position: { x: 20, y: 65 },
    icon: '📖',
  },
  {
    id: 'M032',
    name: '天火焚城',
    description: '究极攻城：解锁火攻机关',
    branch: 'moxue',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['M022', 'M024'],
    effects: {
      bonuses: { siegeBonus: 1.6 },
      special: { fireArrows: true },
    },
    position: { x: 50, y: 65 },
    icon: '🔥',
  },
  {
    id: 'M033',
    name: '机关天兵',
    description: '机关军团：机关兵全属性+40%，自我修复',
    branch: 'moxue',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['M023', 'M025'],
    effects: {
      bonuses: { attackBonus: 1.4, defenseBonus: 1.4, repairSpeed: 1.5 },
    },
    position: { x: 80, y: 65 },
    icon: '🤺',
  },

  // 第五层：终极机关 (2项) [互斥]
  {
    id: 'M041',
    name: '鲁班七号',
    description: '机关终极：解锁究极机关兵鲁班七号',
    branch: 'moxue',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['M031', 'M033'],
    mutuallyExclusive: ['M042'],
    effects: {
      bonuses: { attackBonus: 1.5, defenseBonus: 1.5, speedBonus: 1.3 },
    },
    position: { x: 35, y: 85 },
    nodeShape: 'hexagon',
    icon: '🏆',
    quote: '机关算尽，巧夺天工',
  },
  {
    id: 'M042',
    name: '天崩地裂',
    description: '攻城终极：解锁终极攻城武器地动仪炮',
    branch: 'moxue',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['M031', 'M032'],
    mutuallyExclusive: ['M041'],
    effects: {
      bonuses: { siegeBonus: 2.0 },
    },
    position: { x: 65, y: 85 },
    nodeShape: 'hexagon',
    icon: '💥',
    quote: '天崩地裂，城池化为尘土',
  },
];
